import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import AlertComponent from '../../../components/stories/molecules/alerts'
import { buttonVariantOptions } from '../../../components/stories/atoms/button/constants'
import { alertVariantComponentOptions } from '../../../components/stories/molecules/alerts/constants'

const DeactivateProjectAlert = ({ onClose, onConfirm, isLoading }) => {
  const { formatMessage } = useIntl()

  const handleLeaveProject = (e) => {
    onConfirm(e)
    onClose(e)
  }

  return (
    <AlertComponent
      activeOverlay={true}
      variant={alertVariantComponentOptions.DANGER}
      title={`${formatMessage({ id: 'deactivate_projects' }, { count: 1 })}?`}
      description={formatMessage({ id: 'deactivate_project_warning' })}
      onClickOutside={onClose}
      actionButtons={[
        {
          variant: buttonVariantOptions['TERTIARY-HOLLOW'],
          onClick: onClose,
          children: formatMessage({ id: 'cancel' }),
          fullWidth: true
        },
        {
          variant: buttonVariantOptions['PRIMARY-DESTRUCTIVE'],
          onClick: handleLeaveProject,
          children: formatMessage({ id: 'deactivate_projects' }, { count: 1 }),
          isLoading,
          disabled: isLoading,
          fullWidth: true
        }
      ]}
    />
  )
}

DeactivateProjectAlert.propTypes = {
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  isLoading: PropTypes.bool
}

export default DeactivateProjectAlert
